define('views/modules/goal/edit/types/duration-goal',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // views
    'views/modules/goal/edit/types/main-goal',
    'views/parts/form/textbox',
    // templates
    'text!templates/modules/goal/edit/types/duration-goal.html',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // views
    VMainGoal,
    VTextBox,
    // templates
    TDurationGoal
) {

    var VDurationGoal = VMainGoal.extend({
        template: TDurationGoal,

        regions: _.extend(VMainGoal.prototype.regions, {
            minutes: '.time-minutes-input',
            hours: '.time-hours-input',
        }),

        initialize: function(opt) {
            this.options = _.extend({}, {
                endValueAttr: 'endValue'
            }, opt);

            VMainGoal.prototype.initialize.call(this, this.options);

            var model = this.model,
                view = _.extend(this.view, {
                    hours: new VTextBox({ type: 'number', attribute: 'timeHours', model: model, labelposition: 'top', placeholder: 'Hours' }),
                    minutes: new VTextBox({ type: 'number', attribute: 'timeMinutes', model: model, labelposition: 'top', placeholder: 'Minutes' }),
                });
        },

        render: function() {
            VMainGoal.prototype.render.apply(this, arguments);

            var view = this.view,
                zone = this.zone;

            this.assign(view.hours, zone.$hours)
                .assign(view.minutes, zone.$minutes);

            return this;
        },

        ////////////
        // events //
        ////////////

    });

    return VDurationGoal;
});

